export default __webpack_public_path__ + "static/media/flag-guam.0317c88d.svg";